import React from 'react';
import { Translate } from 'core/translate';
import { PriceWithConditionalNotification } from '../../../components/mathBox/Price';
import { useTranslate } from '../../../../core/translate';
import { withNotifications } from '../../../common/notifications/NotificationsContext';

const NetPriceBox = ({ pricing, notifications }) => {
  const { normalizedNetPriceDisplay } = pricing;
  const translate = useTranslate();
  const priceBox = (
    <div className="net-price-box__net-price">
      <PriceWithConditionalNotification
        isNetPrice
        notificationName="msrp"
        useModal>
        {normalizedNetPriceDisplay}
      </PriceWithConditionalNotification>
    </div>
  );
  return (
    <div className="net-price-box">
      <div className="net-price-box__inner">
        <div className="net-price-box__net-price-label">
          <Translate value="net.price.summary.v3" />
          {priceBox}
        </div>
        {pricing.accessoriesTotal ? (
        <>
          <div className="net-price-box__accessories-net-price">
            <span className="net-price-box__accessories-label">
              {translate('net.price.accessories.label.plus.v3')}
              <span className="net-price-box__accessories-price">
                {pricing.accessoriesTotal.text}
              </span>
              {translate('net.price.accessories.label.in.v3')}
            </span>
            <span className="net-price-box__accessories-disclaimer">
              <a
                onClick={(event) => {
                  event.preventDefault();
                  notifications.show(
                    translate('accessories.price.disclaimer'),
                    event
                  );
                }}>
                {translate('accessories.price.label')}
              </a>
            </span>
          </div>
          <div className="net-price-box__accessories-net-price-asterisk">
            <span className="net-price-box__accessories-label">
              {translate('net.price.accessories.label.plus.v3')}
              <span className="net-price-box__accessories-price">
                <a
                  onClick={(event) => {
                    event.preventDefault();
                    notifications.show(
                      translate('accessories.price.disclaimer'),
                      event
                    );
                  }}>
                  {pricing.accessoriesTotal.text}
                  <sup className="dealer-installed-accessories__total-asterisk">**</sup>
                </a>
              </span>
                {translate('net.price.accessories.label.in.v3')}
              </span>
              <span className="net-price-box__accessories-disclaimer">
                {translate('accessories.price.label')}
            </span>
          </div>
          </>
        ) : null}
      </div>
    </div>
  );
};

export default withNotifications(NetPriceBox);
